import { ComponentProps, useId } from 'react';
import { TopicTooltip } from '@/components/TopicTags/TopicTooltip';
import { TopicTag } from '@/features/analyze/components/Tag';

export type TopicTagWithTooltipProps = {
  name: string;
  description?: string | null;
  themes?: readonly string[] | null;
  isSocialIssue?: boolean | null;
} & Pick<ComponentProps<typeof TopicTag>, 'icon' | 'onClick'>;

export const TopicTagWithTooltip = ({
  name,
  description,
  themes,
  isSocialIssue,
  icon,
  onClick,
}: TopicTagWithTooltipProps) => {
  const tooltipId = useId();

  return (
    <div className="group relative inline-flex">
      <TopicTag
        icon={icon}
        text={name}
        isSocialIssue={isSocialIssue ?? false}
        onClick={onClick}
        aria-describedby={tooltipId}
        tabIndex={0}
      />
      <div className="pointer-events-none absolute bottom-full left-0 z-50 mb-2 hidden group-focus-within:block group-hover:block">
        <TopicTooltip
          id={tooltipId}
          name={name}
          description={description}
          themes={themes}
          isSocialIssue={isSocialIssue ?? false}
          className="pointer-events-auto"
        />
      </div>
    </div>
  );
};
